import isUndefined from 'lodash/isUndefined';
import React from 'react';
import { StyledInput, StyledInputLabel } from './generalInput.style';

type Props = {
  value: string;
  label: string;
  isNumber: boolean;
  placeholder?: string;
  step?: string;
  onChange: (value: string) => void;
  ref?: React.RefObject<HTMLInputElement>;
};

const GeneralInput: React.FC<Props> = (props) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.onChange && event.target.validity.valid) {
      if (event.target.value.match(/^$|^[0-9]*\.?[0-9]*$/)) {
        props.onChange(event.target.value.replace(/^0+([1-9]+)/, '$1'));
      }
    }
  };

  const value = isUndefined(props.value) ? '' : props.value;
  return (
    <>
      {props.label && (
        <StyledInputLabel className="input-label-color">
          {props.label}
        </StyledInputLabel>
      )}
      <StyledInput
        className="input-border input-bg-color input-placeholder-color"
        ref={props.ref}
        type="string"
        placeholder={props.placeholder || '0'}
        pattern={props.isNumber ? '[0-9]+.?[0-9]*' : undefined}
        // Note: only the most basic pattrn attr works, don't use it, acks weird
        min={0}
        value={value}
        onChange={onChange}
      />
    </>
  );
};

export default GeneralInput;
